<template lang='pug' src='./custom-home-welcome.pug'></template>

<script>
import Icon from 'components/icon/icon'

export default {
  props: ['props'],
  components: {
    Icon
  },
  methods: {
    onScroll ({ going }) {
      if (going === this.$waypointMap.GOING_OUT) {
        this.$store.dispatch('VIEW_NAV', true)
      }
      if (going === this.$waypointMap.GOING_IN) {
        this.$store.dispatch('VIEW_NAV', false)
      }
    },
    showContent (i) {
      this.$store.dispatch('VIEW_TYPES', i)
    }
  }
}
</script>



// WEBPACK FOOTER //
// custom-home-welcome.vue?a044e050